module.exports = __webpack_public_path__ + "static/media/fav.82af53ba.svg";